<style lang='scss'>
</style>

<script>
import Layout from '@layouts/main'
import moment from 'moment';
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';

export default {
	components: { Layout, Datatable },
  data() {
    return {
			tableData : [],
			gitname : '',

			tableOption1 : {
				columns : [
					{data : 'name', },
					{data : 'path', },
					{data : 'info.mtimeMs', },
				],
				columnDefs: [
					{
						render : (data, type, row) => {
							return moment(data).format('YYYY.MM.DD HH:mm:ss');
						},
						targets : 2
					},
				]
			},

		}
	},
	beforeCreate() {
	},
	created() {
		this.load();
	},
	mounted() {
	},
	methods : {
		load() {
			AxiosHelper.get(`/api/git`).then(ret => {
				this.tableData = ret.data;
			});
		},

		createGit() {
			AxiosHelper.post("/api/git", {
				gitname : this.gitname,
			}).then(ret => {
				this.pushMessage('생성완료');
				this.load();
			});
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader title="Git 목록" />

		<C.Row>
			<C.Col md="3">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						조건 설정
					</C.CardHeader>
					<C.CardBody>
						<div class="form-group row mb-3">
							<div class="col-12">
								<input v-model="gitname" type="text" class="form-control" placeholder="생성할 Git 이름"/>
							</div>
						</div>
						<div class="button-list">
							<button type="button" class="btn btn-blue" @click="createGit">생성</button>
						</div>
					</C.CardBody>
				</C.Card>
			</C.Col>
			<C.Col md="9">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						NAS의 Git repository 관리
					</C.CardHeader>
					<C.CardBody>
						<Datatable
							:option="tableOption1"
							:data="tableData"
						>
							<template v-slot:thead>
								<tr>
									<th>Git이름</th>
									<th>경로</th>
									<th>수정시간</th>
								</tr>
							</template>
						</Datatable>
					</C.CardBody>
				</C.Card>
			</C.Col>
		</C.Row>
  </Layout>
</template>